var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('a[href*="choicehotels.com"]').each(function() {
        var $this = $(this);       
        var _href = $this.attr("href");
        if (_href.indexOf('?') >= 0) {
            $this.attr("href", _href + "&mc=frtmxxpx");
        }else{
            $this.attr("href", _href + "?mc=frtmxxpx");
        } 
    }); 
    
    window.onload = function() { 
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();

			let animatedEl = document.getElementsByClassName('animate');
			const h = window.innerHeight;
			var i;
			for (i = 0; i < animatedEl.length; i++) {
				var viewportOffset = animatedEl[i].getBoundingClientRect();
				let topPos = viewportOffset.top;
				//animatedEl[i].innerHTML = topPos;
				if(topPos <= h*0.8){
					animatedEl[i].classList.add('fade-in');
				}
			}
		})
	}; 

	$('a[href*="choicehotels.com"]').each(function() {
        var $this = $(this);       
        var _href = $this.attr("href"); 
        $this.attr("href", _href + '?mc=frtmxxpx');
    });

    $('.sym-slides').slick({
        accessibility: false
    });
    setTimeout(function(){ 
        $('a[href*="/privacy-policy"]').each(function(){ 
            $(this).attr("href", "/choice-hotels-privacy-policy"); 
        });
    }, 2000);

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}